import AbstractFetch from '~/repositories/AbstractFetch';
import type { IFetchOptions, IResponse } from '~/types/repositories';
import type { IUserData } from '~/modules/user/types/user';

export default class Users extends AbstractFetch {
  private static readonly USER_DATA = 'v1/users/{id}';
  private static readonly PASSWORD = 'v1/users/{id}/password';
  private static readonly BALANCE = 'v1/users/balance';

  constructor(fetchOptions: IFetchOptions) {
    super(fetchOptions.baseURL, fetchOptions.fetch);
  }

  async getUserData({ id }: { id: number }): Promise<IResponse<IUserData>> {
    return this.fetch(Users.USER_DATA.replace('{id}', String(id)), {
      method: 'GET',
    });
  }

  async updateUserData({ id, data }: { id: number; data: any }): Promise<IResponse<void>> {
    return this.fetch(Users.USER_DATA.replace('{id}', String(id)), {
      method: 'POST',
      body: data,
    });
  }

  async getBalance(): Promise<IResponse<{ available: number }>> {
    return this.fetch(Users.BALANCE, {
      method: 'GET',
    });
  }
}
